<template>
    <div v-if="product" v-bind:class="{ 'is-active': isActive }" class="modal modal-fx-fadeInScale">
        <div class="modal-background" v-on:click="onCloseSelected"></div>
        <div class="modal-content">
            <div class="box columns is-marginless">
                <div class="is-hidden-touch column is-paddingless sidebar" v-bind:style="[sidebarStyle]">
                </div>
                <div class="column has-text-left product-info">
                    <button class="delete" aria-label="close" v-on:click="onCloseSelected"></button>

                    <h1 class="title">{{ product.name | capitalize }}</h1>
                    <h1 class="subtitle">{{ product.presentation }}</h1>

                    <span class="price">$ {{ product.price }}</span>
                    <p class="description is-size-7">{{ product.description }}</p>

                    <div class="quantity field is-grouped is-grouped-right">
                        <p class="control">
                            <spinner v-model="quantity"></spinner>
                        </p>

                        <p class="control">
                            <a class="button is-primary" v-on:click="onAddToCartSelected">Agregar</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from '../ui/Spinner';

    export default {
        name: 'ProductModal',
        components: {Spinner},

        data() {
            return {
                sidebarStyle: {},
                quantity: 1,
                isActive: false,
                product: null
            }
        },

        methods: {
            show(p) {
                this.product = p;
                this.quantity = 1;
                this.isActive = true;

                if(p.image && p.image.webPath) {
                    this.sidebarStyle.background = 'url(' + this.$options.filters.toCDNPath(p.image.webPath) + ') no-repeat center center';
                }
                else {
                    this.sidebarStyle.background = '';
                }
            },

            close() {
                this.isActive = false;
            },

            onCloseSelected() {
                this.isActive = false;
            },

            onAddToCartSelected() {
                this.$store.dispatch('cart/add', { 
                    item: {
                        product: this.product.id,
                        quantity: this.quantity
                    }
                });

                this.close();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~bulma/sass/utilities/_all';

    .columns {
        padding: 0;

        .column {
            padding: 20px;
        }

        .sidebar {
            padding: 0;
            height: 500px;

            background-size: cover;
            //background: url('./../../assets/img/background_8.jpg') no-repeat center center;

            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }
    }

    .delete {
        position: absolute;
        top: 10px;
        right: 25px;
    }

    .product-info {
        display: flex;
        flex-direction: column;

        .price {
            color: $primary;
            font-weight: bold;
            font-size: 1.2em;
        }

        .description {
            margin-top: 10px;
            margin-bottom: 20px;
        }

        .quantity {
            margin-left: 50%;
            margin-top: auto;

            .spinner {
                width: 100px;
            }
        }
    }
</style>